module.exports = __webpack_public_path__ + "static/media/contacts-512.4988d41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contacts-512.png
// module id = 1160
// module chunks = 0